import React, {useMemo, useContext} from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import context from "components/Shared/MSidebar/utility/context";

const DrawerToggle = () => {
  const {
    open,
    toggleSidebar: onClick
  } = useContext(context);
  const ToggleIcon = useMemo(
    () => open ? ChevronLeftRoundedIcon : ChevronRightRoundedIcon,
    [open]
  );
  return (
  <div className="DrawerToggle-Root">
      <IconButton
        {...{onClick}}
        size={"small"}
        className="DrawerToggle-IconButton"
      >
        <ToggleIcon/>
      </IconButton>
  </div>
  );
};

DrawerToggle.defaultProps = {
  open: true,
};

DrawerToggle.propTypes = {
  open: PropTypes.bool,
};

export default DrawerToggle;